
import React, { useEffect } from 'react';
import {
  IconCard,
  Radio,
} from 'gatorcomponents';
import { CC_FLAGS, FAST_CHECKOUT_CREDIT_CARD_METHODS } from '../../FastCheckout.enum';
import * as Styles from './FastCheckoutCC.styles';
import masterCardFlag from '../../media/mastercard.svg';
import visaFlag from '../../media/visa.svg';
import withErrorBoundary from '@/utils/errorBoundary';
import { format, parse } from 'date-fns';
import { config } from '@/config';

const FastCheckoutCC = ({
  iframe, locale, renewalDate, creditCardMethod, setCreditCardMethod, currentCreditCard,
}) => {
  const hasACreditCardRegistered = currentCreditCard && currentCreditCard.id && currentCreditCard.cardLastFour;

  useEffect(() => {
    if (hasACreditCardRegistered) {
      setCreditCardMethod(FAST_CHECKOUT_CREDIT_CARD_METHODS.ALREADY_REGISTERED);
    }
  }, [hasACreditCardRegistered, setCreditCardMethod]);

  const {
    ccAlreadyRegistered, newCC, alreadyRegisteredTitle, expire, nextPayment, dateGrouper,
  } = locale;

  const renderMaskedLastFour = (CCNumber) => {
    const CCNumberWithoutLastFour = CCNumber.slice(0, -4);
    const blocks = [];
    for (let i = 0; i < CCNumberWithoutLastFour.length; i += 4) {
      blocks.push({ value: CCNumberWithoutLastFour.slice(i, i + 4), id: i });
    }

    return (
      <>
        {
          blocks.map(block => (
            <Styles.CCNumberBlock key={block.id}>
              {block.value.split('').map((char, index) => (char === '*' ? (
                <Styles.CensuredNumber key={`${block.id}-${index.toString()}`} />
              ) : null))}
            </Styles.CCNumberBlock>
          ))
        }
        <Styles.CCLastFour>{CCNumber.slice(-4)}</Styles.CCLastFour>
      </>
    );
  };

  const formatRenewalDate = () => {
    if (renewalDate) {
      const date = parse(renewalDate, 'dd/MM/yyyy', new Date());
      return format(date, `d '${dateGrouper}' MMMM '${dateGrouper}' yyyy`, { locale: config.LANG.dateFns });
    }
  };

  const ccFlag = () => {
    switch (currentCreditCard.cardType) {
      case CC_FLAGS.MASTERCARD:
        return <Styles.CCFlag src={masterCardFlag} alt="Mastercard" />;
      case CC_FLAGS.VISA:
        return <Styles.CCFlag src={visaFlag} alt="Visa" />;
      default:
        return <IconCard />;
    }
  };

  return (
    <>
      {hasACreditCardRegistered && (
        <Styles.RadiosWrapper>
          <Styles.RadioWrapper
            htmlFor="#alreadyRegisteredRadio"
            data-testid="alreadyRegistered"
            onClick={() => setCreditCardMethod(FAST_CHECKOUT_CREDIT_CARD_METHODS.ALREADY_REGISTERED)}
          >
            <Radio checked={creditCardMethod === FAST_CHECKOUT_CREDIT_CARD_METHODS.ALREADY_REGISTERED} variant="blue" id="alreadyRegisteredRadio" />
            <Styles.RadioLabel>{ccAlreadyRegistered}</Styles.RadioLabel>
          </Styles.RadioWrapper>
          <Styles.RadioWrapper
            htmlFor="#newCCRadio"
            data-testid="newCC"
            onClick={() => setCreditCardMethod(FAST_CHECKOUT_CREDIT_CARD_METHODS.NEW)}
          >
            <Radio checked={creditCardMethod === FAST_CHECKOUT_CREDIT_CARD_METHODS.NEW} variant="blue" id="newCCRadio" />
            <Styles.RadioLabel>{newCC}</Styles.RadioLabel>
          </Styles.RadioWrapper>
        </Styles.RadiosWrapper>
      )}

      <Styles.IframeWrapper shouldHide={creditCardMethod !== FAST_CHECKOUT_CREDIT_CARD_METHODS.NEW}>
        {iframe}
      </Styles.IframeWrapper>

      {creditCardMethod === FAST_CHECKOUT_CREDIT_CARD_METHODS.ALREADY_REGISTERED && (
        <Styles.AlreadyRegisteredWrapper>
          <Styles.AlreadyRegisteredTitle>{alreadyRegisteredTitle}</Styles.AlreadyRegisteredTitle>
          <Styles.CardInfoWrapper>
            <Styles.FlagNumberWrapper>
              <Styles.CCFlagWrapper>
                {ccFlag()}
              </Styles.CCFlagWrapper>
              <Styles.CCNumberWrapper>
                <Styles.CCLastFourWrapper>
                  {renderMaskedLastFour(currentCreditCard.cardLastFour)}
                </Styles.CCLastFourWrapper>
              </Styles.CCNumberWrapper>
            </Styles.FlagNumberWrapper>
            <Styles.CCExpireDate>
              {`${expire} ${currentCreditCard.expDate}`}
            </Styles.CCExpireDate>
          </Styles.CardInfoWrapper>
          <Styles.NextPaymentWarning>{nextPayment}</Styles.NextPaymentWarning>
          <Styles.RenewalDate>{formatRenewalDate()}</Styles.RenewalDate>
        </Styles.AlreadyRegisteredWrapper>
      )}
    </>
  );
};

export default withErrorBoundary(FastCheckoutCC, 'FastCheckoutCC');
